import api from "../../services/api";

export default {
  actions: {
    createUser({ commit }, user) {
      commit("clearError");
      commit("setLoading", true);

      const newUser = {
        name: user.name,
        city_id: user.city_id,
        address: user.address,
        phone: user.phone,
        email: user.email,
        username: user.username,
        password: user.password,
        isBrasil: user.isBrasil,
        accepted_consent_term: user.accepted_consent_term
      };

      return new Promise((resolve, reject) => {
        api
          .post("users/", newUser)
          .then(result => {
            commit("setProfile", result.data);
            resolve(result.data);
          })
          .catch(err => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    updateProductUserRole({ commit }, updatedProduct) {
      commit("clearError");
      commit("setLoading", true);

      return new Promise((resolve, reject) => {
        const userId = updatedProduct.user.id;
        const productId = updatedProduct.id;
        const role = updatedProduct.role;
        const body = {
          role: role
        };
        api
          .put(`users/${userId}/products/${productId}/role`, body)
          .then(result => {
            commit("updateProduct", updatedProduct);
            resolve(result.data);
          })
          .catch(err => {
            commit("setError", err.response || err);
            try {
              reject(err.response.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/user/index.js